import React from 'react';

interface ControlPanelProps {
  error: string | null;
  isLoading: boolean;
  avatarLoaded: boolean;
  conversationStarted: boolean;
  isPlaying: boolean;
  onPlayPause: () => void;
  onRetry: () => void;
  onClearError: () => void;
  onStartPoc?: () => void;
  onStop?: () => void;
  pocStarted?: boolean;
  userRoleName?: string;
}

const ControlPanel: React.FC<ControlPanelProps> = ({
  error,
  isLoading,
  avatarLoaded,
  conversationStarted,
  isPlaying,
  onPlayPause,
  onRetry,
  onClearError,
  onStartPoc,
  onStop,
  pocStarted = false,
  userRoleName,
}) => {
  return (
    <div style={{
      position: 'absolute',
      top: '20px',
      left: '20px',
      zIndex: 1000,
      background: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '15px',
      borderRadius: '10px',
      maxWidth: '300px',
    }}>
      {error && (
        <div style={{ color: '#ff6b6b', fontSize: '12px', marginBottom: '10px' }}>
          ❌ {error}
          <br />
          <button
            onClick={() => {
              onClearError();
              onRetry();
            }}
            style={{
              marginTop: '5px',
              padding: '4px 8px',
              fontSize: '10px',
              background: '#ff6b6b',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            Retry
          </button>
        </div>
      )}

      {isLoading && (
        <div style={{ fontSize: '12px', marginBottom: '10px' }}>
          🎙️ Generating speech...
        </div>
      )}

      {!avatarLoaded && (
        <div style={{ fontSize: '12px', marginBottom: '10px' }}>
          🤖 Loading avatar... this could take 1-2 minutes
        </div>
      )}

      {!pocStarted ? (
        <button
          onClick={() => {
            onStartPoc?.(); // Trigger POC started state in App.tsx
            onPlayPause();   // Also start the conversation immediately
          }}
          disabled={isLoading || !avatarLoaded}
          style={{
            background: '#4ecdc4',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: avatarLoaded && !isLoading ? 'pointer' : 'not-allowed',
            fontSize: '14px',
            fontWeight: '500',
            opacity: avatarLoaded && !isLoading ? 1 : 0.6,
          }}
        >
          {isLoading ? '⏳ Loading...' : `🚀 Start${userRoleName ? ` - ${userRoleName}` : ''}`}
        </button>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ fontSize: '12px', color: '#4ecdc4', fontWeight: '500' }}>
            💬 Conversation active
          </div>
          {onStop && (
            <button
              onClick={onStop}
              style={{
                background: '#ff6b6b',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: '500',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                (e.target as HTMLButtonElement).style.backgroundColor = '#ff5252';
                (e.target as HTMLButtonElement).style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                (e.target as HTMLButtonElement).style.backgroundColor = '#ff6b6b';
                (e.target as HTMLButtonElement).style.transform = 'translateY(0px)';
              }}
            >
              🛑 End Conversation
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ControlPanel;